module.exports = __webpack_public_path__ + "img/exploreButton.652a855d.svg";